export default __webpack_public_path__ + "static/safety-icon-b87559d24ce035f61e613e42fe22e924.png";